import React from 'react';
import './CustomProgressBar.scss';

const CustomProgressBar = ({ value, id  }) => <progress className="download-progress" id={id || 'progress'} value={value} max="100" />;

export default CustomProgressBar;